import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Component from 'flarum/common/Component';

// TODO: possible rewrite
// 1) Hook MutationObserver of google translator service and first iterate over mutation objects and add skiptranslate class after that call original google callback
// 2) Initial load google script ( before page is loaded ) because of google translator service on initialization stage iterate over document childs and translate nodes,
//    and we can't to skip of translation this nodes ( because of we are have onlu mutator hook ), so we need to initialize google script at early stage of loading page

export default () => {
    selectDefaultLanguage();
    skipTranslate();
    addResources();
}

let addedResources = false;
const addResources = async () => {
    if (addedResources) return;
    await $.getScript('//translate.google.com/translate_a/element.js?cb=googleTranslateServiceInit&client=wt');
    addedResources = true;
};

global.googleTranslateServiceInit = () => {
    const locale = app.data.locale;
    if (locale != app.data.default_locale) {
        // initiate translate service
        const gtranslate = new google.translate.TranslateService({ useSecureConnection: true });
        // translate whole page
        gtranslate.translatePage('auto', locale);
    }
}

function skipTranslate() {
    const defaults = {
        'Avatar': Number.MAX_SAFE_INTEGER,
        'Widget': Number.MAX_SAFE_INTEGER,
        'EditUserModal-groups': Number.MAX_SAFE_INTEGER,
        'UserCard-profile': Number.MAX_SAFE_INTEGER,
        'EventPost-info': Number.MAX_SAFE_INTEGER,
        'Notification-content': Number.MAX_SAFE_INTEGER,
        'App-titleControl': Number.MAX_SAFE_INTEGER,
        'CheatpanelPage-grid-rowItem': Number.MAX_SAFE_INTEGER,
        'EditUserApplicationsModal-grid-rowItem': Number.MAX_SAFE_INTEGER,
        'GlobalApplicationControlModal-grid-rowItem': Number.MAX_SAFE_INTEGER,
        'ApplicationConfigPage-grid-variable': Number.MAX_SAFE_INTEGER,
        'PostMention': Number.MAX_SAFE_INTEGER,
        'UserMention': Number.MAX_SAFE_INTEGER,
        'GroupMention': Number.MAX_SAFE_INTEGER,
        'DiscussionSearchResult-title': Number.MAX_SAFE_INTEGER,
        'DiscussionListItem-title': Number.MAX_SAFE_INTEGER,
        'DiscussionHero-title': Number.MAX_SAFE_INTEGER,
        'TagLinkButton': Number.MAX_SAFE_INTEGER,
        'TagTile-name': Number.MAX_SAFE_INTEGER,
        'TagTile-lastPostedDiscussion-title': Number.MAX_SAFE_INTEGER,
        'TagTile-children': Number.MAX_SAFE_INTEGER,
        'SelectTagListItem-name': Number.MAX_SAFE_INTEGER,
        'SelectTagListItem-description': Number.MAX_SAFE_INTEGER,
        'TagLabel-name': Number.MAX_SAFE_INTEGER,
        'ApplicationStatus-name': Number.MAX_SAFE_INTEGER,
        'item-allDiscussions': Number.MAX_SAFE_INTEGER,
        'item-following': Number.MAX_SAFE_INTEGER,
        'item-tags': Number.MAX_SAFE_INTEGER,
        'item-title': Number.MAX_SAFE_INTEGER,
        'item-terminalPost': Number.MAX_SAFE_INTEGER,
        'item-history-attachment': Number.MAX_SAFE_INTEGER,
        'item-bio': Number.MAX_SAFE_INTEGER,
        'username': Number.MAX_SAFE_INTEGER,
        'locale-label': Number.MAX_SAFE_INTEGER
    };

    extend(Component.prototype, [ 'oncreate', 'onupdate' ], function () {
        const locale = app.data.locale;
        if (locale != app.data.default_locale) {
            // Skip translate for target DOM elements.
            for (const [className, limitCount] of Object.entries(defaults)) {
                this.$(`.${className}`).addClass((idx) => (idx < limitCount) ? 'skiptranslate' : '');
            }
        }
    });
}

function selectDefaultLanguage() {
    window.addEventListener('load', function () {
        const locale = (navigator.language || navigator.userLanguage).substr(0, 2);
        if (Object.keys(app.data.locales).map((locale) => locale.substr(0, 2)).includes(locale)) {
            if (app.data.locale !== locale) {
                const user = app.session?.user;
                if (user) {
                    const preferences = user.preferences();
                    if (preferences['locale'] === null) {
                        user.savePreferences({ locale }).then(() =>
                            window.location.reload()
                        );
                    }
                } else {
                    const preferences = document.cookie.match('locale=([^;]*)');
                    if (preferences === null) {
                        document.cookie = `locale=${locale}; path=/; expires=Tue, 19 Jan 2038 03:14:07 GMT`;
                        window.location.reload();
                    }
                }
            }
        }
    });
}
